'use client';
import { useEffect, useRef } from 'react';

// Lets something that hides part of the page, such as a collapsed accordion,
// be asked from outside to show it. The request is an event that bubbles up
// from what should be shown, the way `beforematch` does for the browser's
// find in page, so whoever asks doesn't need to know what hides it.
const REVEAL = 'reveal';

// Opens whatever hides the element. Returns how many milliseconds it takes
// to finish opening, 0 when nothing hid it.
export const reveal = (element) => {
    const event = new CustomEvent(REVEAL, {
        bubbles: true,
        detail: { openingTime: 0 },
    });
    element.dispatchEvent(event);
    return event.detail.openingTime;
};

// Returns a ref for what a collapsible thing hides. While it is closed, a
// reveal of something inside calls `setIsOpen` with true, and opening takes
// `openingTime` milliseconds.
export const useRevealable = (isOpen, setIsOpen, openingTime) => {
    const ref = useRef(null);
    useEffect(() => {
        const element = ref.current;
        if (isOpen || !element) return;
        const open = (event) => {
            setIsOpen(true);
            event.detail.openingTime = Math.max(
                event.detail.openingTime,
                openingTime
            );
        };
        element.addEventListener(REVEAL, open);
        return () => element.removeEventListener(REVEAL, open);
    }, [isOpen, setIsOpen, openingTime]);
    return ref;
};
